import base2 from './base2.repository';

export default {
    get: (params) => base2.get('clients/contractor-document-types', { params }),
    getById: (id) => base2.get(`clients/contractor-document-types/${id}`),
    save: (payload) => base2.post('clients/contractor-document-types', payload),
    update: (id, payload) => base2.put(`clients/contractor-document-types/${id}`, payload),
    delete: (id) => base2.delete(`clients/contractor-document-types/${id}`),
};
